import { AccordionCard } from '../../../../../core/components/templates/AccordionCard';
import { Typography } from '../../../../../core/components/molecules/Typography';
import Checkbox from '../../../../../core/components/atoms/Checkbox';
import BrainLoadingWrapper from '../../../../../core/components/molecules/BrainLoading';
import { ResponsiveTable } from '../../../../../core/components/organism/Table';

interface SubjectListProps {
  isLoading: boolean;
  subjects: any[];
  selectedSubjects: string[];
  setSelectedSubjects: (subjects: string[]) => void;
  withShadowLevel2?: boolean;
}

const SubjectList = ({
  isLoading,
  subjects,
  selectedSubjects,
  setSelectedSubjects,
  withShadowLevel2 = false,
}: SubjectListProps) => {
  if (isLoading) {
    return (
      <div>
        <BrainLoadingWrapper />
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-lg pb-[3rem]`}>
      <div className='flex flex-row items-center justify-between'>
        <Typography type='titleSection' size='h6'>
          Módulos
        </Typography>
        <Typography>{subjects?.length ?? 0} módulos</Typography>
      </div>
      <div className='flex flex-col gap-lg '>
        {subjects?.map((module, moduleIndex) => {
          const tableData = module.subjects.map(
            (subject: {
              title: string;
              subjectId: string;
              id: string;
              data: number[];
            }, subjectIndex: number) => {
              const weeks = subject.data
                .map((week: number) => week.toString())
                .reduce((acc, curr, index, array) => {
                  if (index === 0) return curr;
                  if (index === array.length - 1) return `${acc} e ${curr}`;
                  return `${acc}, ${curr}`;
                }, '');
              const isNotInSchedule = (subject.data || []).length === 0;

              return {
                assuntos: (
                  <div className='flex flex-col gap-xs items-start w-full'>
                    <Checkbox
                      label={subject.title}
                      checked={selectedSubjects.includes(subject.subjectId)}
                      onChange={() => {
                        if (selectedSubjects.includes(subject.subjectId)) {
                          setSelectedSubjects(
                            selectedSubjects.filter(
                              (id) => id !== subject.subjectId
                            )
                          );
                        } else {
                          setSelectedSubjects([
                            ...selectedSubjects,
                            subject.subjectId,
                          ]);
                        }
                      }}
                    />
                    {isNotInSchedule && (
                      <span className='flex text-[10px] italic text-mono-color-dark'>
                        Este Assunto não está em seu Cronograma de Estudos
                      </span>
                    )}
                  </div>
                ),
                semana: moduleIndex === 0 && subjectIndex === 0
                  ? <span data-tour="subject-week-column">{weeks || '-'}</span>
                  : weeks || '-',
              };
            }
          );

          return (
            <AccordionCard
              key={moduleIndex}
              className='dark:bg-[#2E3847]'
              title={module.title}
              shadow={withShadowLevel2 ? 'shadow-level-2' : ''}
              {...(moduleIndex === 0 && { 'data-tour': 'subject-module-accordion' })}
            >
              <ResponsiveTable
                headers={[
                  {
                    label: 'Assuntos',
                    key: 'assuntos',
                    isPrimary: true,
                  },
                  {
                    label: 'Semana',
                    key: 'semana',
                  },
                ]}
                data={tableData}
              />
            </AccordionCard>
          );
        })}
      </div>
    </div>
  );
};

export default SubjectList;
